/* eslint-disable react/jsx-no-target-blank */
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './styles.css';

export interface ILabel {
  invalid: boolean;
}

export const Label = ({ invalid }: ILabel) => (
  <span {...mergeStyles(styles['term-description'], invalid && styles['label-invalid'])}>
    Отправляя анкету, я даю согласие на обработку моих персональных данных в соответствии с{' '}
    <a className={styles['link']} href="https://www.cian.ru/help/about/36526/" target="_blank">
      политикой конфиденциальности
    </a>
  </span>
);
